import { NgModule, InjectionToken } from "@angular/core";
import { CommonModule, DatePipe, DecimalPipe } from "@angular/common";
import { SignInComponent } from "./components/login/sign-in/sign-in.component";
import { ForgotComponent } from "./components/login/forgot/forgot.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { RouterModule } from "@angular/router";
import { NewPasswordComponent } from "./components/login/new-password/new-password.component";
import { LoginService } from "./components/login/login.service";
import { LoadingModule } from "ngx-loading";
import { ErrorDialogComponent } from "./components/error-dialog/error-dialog.component";
import { MessageDialogComponent } from "./components/message-dialog/message-dialog.component";
import { PrivacyPolicyDialogComponent } from "./components/privacy-policy-dialog/privacy-policy-dialog.component";
import { MatSelectModule, MatDialog, MatDialogModule } from "@angular/material";
import { GraphComponent } from "./graph/graph.component";
import { ChartsModule } from "ng2-charts";
import { OwlDateTimeModule, OwlNativeDateTimeModule } from "ng-pick-datetime";
import { GeneralService } from "./services/general.service";
import { BoxOfflineComponent } from "./components/box-offline/box-offline.component";
import { NoDevicesComponent } from "./components/no-devices/no-devices.component";
import { IsAliveComponent } from "./components/is-alive/is-alive.component";
import { CookiesComponent } from "./cookies/cookies.component";
import { TranslateModule } from "@ngx-translate/core";
import { DeleteConfirmDialogComponent } from "./components/delete-confirm-dialog/delete-confirm-dialog.component";
import { DatePipeProxy } from "./translate/datePipeProxy.component";
import { TutorialComponent } from "./components/tutorial/tutorial.component";
import { TutorialTabComponent } from "./components/tutorial/tutorial-tab/tutorial-tab.component";
import { VideoTutorialComponent } from "./components/tutorial/video-tutorial/video-tutorial.component";
import { DeviceManualComponent } from "./components/tutorial/device-manual/device-manual.component";
import { NewGraphComponent } from "./new-graph/new-graph.component";
import { FirstLoginComponent } from "./components/login/first-login/first-login.component";
import { NoSmartMeterComponent } from "./components/no-smart-meter/no-smart-meter.component";
import { NoHouseUserComponent } from "./components/no-house-user/no-house-user.component";
import { AlertComponent } from "./components/alert/alert.component";
import { AlertService } from "./components/alert/alert.service";
import { TrophyBarComponent } from "./components/trophy-bar/trophy-bar.component";
import { MobileComponent } from "./components/mobile/mobile.component";
import { OnboardingComponent } from "./components/coachmarks/onboarding/onboarding.component";
import { CoachmarkHomeComponent } from "./components/coachmarks/coachmark-home/coachmark-home.component";
import { CoachmarkDeviceComponent } from "./components/coachmarks/coachmark-device/coachmark-device.component";
import { CoachmarkSchedulingComponent } from "./components/coachmarks/coachmark-scheduling/coachmark-scheduling.component";
import { CoachmarkDeviceDetailComponent } from "./components/coachmarks/coachmark-device-detail/coachmark-device-detail.component";
import { CoachmarkUsersComponent } from "./components/coachmarks/coachmark-users/coachmark-users.component";
import { CoachmarkTipsComponent } from "./components/coachmarks/coachmark-tips/coachmark-tips.component";
import { CoachmarkEfficiencyTipsComponent } from "./components/coachmarks/coachmark-efficiency-tips/coachmark-efficiency-tips.component";
import { CoachmarkHouseComponent } from "./components/coachmarks/coachmark-house/coachmark-house.component";
import { CoachmarkHouseDetailComponent } from "./components/coachmarks/coachmark-house-detail/coachmark-house-detail.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    LoadingModule,
    MatSelectModule,
    MatDialogModule,
    ChartsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    TranslateModule,
  ],
  entryComponents: [
    ErrorDialogComponent,
    MessageDialogComponent,
    PrivacyPolicyDialogComponent,
  ],
  providers: [LoginService, DatePipe, DecimalPipe, MatDialog, GeneralService, AlertService],
  declarations: [
    SignInComponent,
    ForgotComponent,
    PageNotFoundComponent,
    NewPasswordComponent,
    ErrorDialogComponent,
    MessageDialogComponent,
    PrivacyPolicyDialogComponent,
    GraphComponent,
    BoxOfflineComponent,
    NoDevicesComponent,
    IsAliveComponent,
    CookiesComponent,
    DeleteConfirmDialogComponent,
    DatePipeProxy,
    TutorialComponent,
    TutorialTabComponent,
    VideoTutorialComponent,
    DeviceManualComponent,
    NewGraphComponent,
    FirstLoginComponent,
    NoSmartMeterComponent,
    NoHouseUserComponent,
    AlertComponent,
    TrophyBarComponent,
    MobileComponent,
    OnboardingComponent,
    CoachmarkHomeComponent,
    CoachmarkDeviceComponent,
    CoachmarkSchedulingComponent,
    CoachmarkDeviceDetailComponent,
    CoachmarkUsersComponent,
    CoachmarkTipsComponent,
    CoachmarkEfficiencyTipsComponent,
    CoachmarkHouseComponent,
    CoachmarkHouseDetailComponent,
  ],
  exports: [
    SignInComponent,
    ForgotComponent,
    GraphComponent,
    BoxOfflineComponent,
    NoDevicesComponent,
    CookiesComponent,
    TranslateModule,
    DatePipeProxy,
    NewGraphComponent,
    AlertComponent,
    TrophyBarComponent,
    MobileComponent,
    OnboardingComponent,
    CoachmarkHomeComponent,
    CoachmarkDeviceComponent,
    CoachmarkSchedulingComponent,
    CoachmarkDeviceDetailComponent,
    CoachmarkUsersComponent,
    CoachmarkTipsComponent,
    CoachmarkEfficiencyTipsComponent,
    CoachmarkHouseComponent,
    CoachmarkHouseDetailComponent,
  ],
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts